import LogoTELD from '@/assets/img/chargingVoucher/logo-tld.png';
import LogoXJCD from '@/assets/img/chargingVoucher/logo-xjcd.png';
import IconXXCD from '@/assets/img/chargingVoucher/logo-xxcd.png';
import IconNFDW from '@/assets/img/chargingVoucher/logo-nfdw.png';
import IconYKC from '@/assets/img/chargingVoucher/logo-ykc.png';

export function getProviderLogo(key) {
  let logo = '';
  switch (key) {
    case '特来电':
    case 'TELD':
    case 'tld':
      logo = LogoTELD;
      break;
    case '星星充电':
    case 'STARCHARGE':
    case 'xxcd':
      logo = LogoXJCD;
      break;
    case '小桔充电':
    case 'XIAOJU':
    case 'xjcd':
      logo = IconXXCD;
      break;
    case '顺易充':
    case 'NWDD':
    case 'nfdw':
      logo = IconNFDW;
      break;
    case '云快充':
    case 'JSYKC':
    case 'jsykc':
      logo = IconYKC;
      break;
    default:
      logo = LogoTELD;
  }
  return logo;
}

export function getMiniProgramConfig(key) {
  let config = {};
  switch (key) {
    case '特来电':
    case 'TELD':
    case 'tld':
      config = {
        appId: 'wx8d32c1a71ecd965d',
        path: 'pages/PowerStation/index',
        text: '特来电'
      };
      break;
    case '星星充电':
    case 'STARCHARGE':
    case 'xxcd':
      config = {
        appId: 'wxb8e2ba3a621b447d',
        path: '/pages/index/index',
        text: '星星充电'
      };
      break;
    case '小桔充电':
    case 'XIAOJU':
    case 'xjcd':
      config = {
        appId: 'wx06cb940499986937',
        path: 'page/home/index',
        text: '小桔充电'
      };
      break;
    case '顺易充':
    case 'NWDD':
    case 'nfdw':
      config = {
        appId: 'wxae048f582b92a2ab',
        path: 'pages/mapStation/map',
        text: '顺易充'
      };
      break;
    case '云快充':
    case 'JSYKC':
    case 'jsykc':
      config = {
        appId: 'wx8a21598d96957d79',
        path: 'pages/ready/ready',
        text: '云快充'
      };
      break;
    default:
      config = {
        appId: 'wx8d32c1a71ecd965d',
        path: 'pages/PowerStation/index',
        text: '特来电'
      };
      break;
  }
  return config;
}
